export const clearHubSpotState = () => {
  if (typeof window === "undefined") return;

  try {
    window.HubSpotConversations?.widget?.close?.();
  } catch (error) {
    console.warn("Failed to close HubSpot widget", error);
  }

  const cookieNames = [
    "messagesUtk",
    "hubspotutk",
    "hs-messages-is-open",
    "hs-messages-hide-welcome-message",
    "hubspotapi-csrf",
  ];

  const expireCookie = (name, domain) => {
    const domainPart = domain ? ` domain=${domain};` : "";
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;${domainPart}`;
  };

  const hostname = window.location.hostname;
  const domainSegments = hostname.split(".");
  const candidateDomains = [undefined];

  if (domainSegments.length > 1) {
    for (let i = 0; i <= domainSegments.length - 2; i += 1) {
      candidateDomains.push(`.${domainSegments.slice(i).join(".")}`);
    }
  }

  cookieNames.forEach((cookie) => {
    candidateDomains.forEach((domain) => expireCookie(cookie, domain));
  });

  const clearStorageKeys = (storage) => {
    if (!storage) return;
    const keys = [];
    for (let i = 0; i < storage.length; i += 1) {
      keys.push(storage.key(i));
    }
    keys.forEach((key) => {
      if (!key) return;
      const lowerKey = key.toLowerCase();
      if (
        lowerKey.includes("hubspot") ||
        lowerKey.includes("hs-message") ||
        lowerKey.includes("messages")
      ) {
        storage.removeItem(key);
      }
    });
  };

  try {
    clearStorageKeys(window.localStorage);
    clearStorageKeys(window.sessionStorage);
  } catch (error) {
    console.warn("Failed to clear HubSpot storage state", error);
  }

  try {
    window.HubSpotConversations?.resetAndReloadWidget?.();
  } catch (error) {
    console.warn("Failed to reset HubSpot widget", error);
  }
};
